(ns web3.view.hiccup)

(defn styles [icon styles]
  (apply update-in icon [1 :style] (fnil merge {}) styles))

(defn class [icon class]
  (update-in icon [1 :class] str " " class))

(defn size
  "Constrain an icon to max-width and max-height (in rem)"
  ([icon the-size] (size icon the-size the-size))
  ([icon max-width max-height]
   (case (first icon)
     :svg
     (update icon 1 assoc :width max-width :height max-height)

     :img
     (update-in icon [1 :style] (fnil merge {})
                {:max-width max-width
                 :max-height max-height}))))
